<template>
  <div class="permissions-list--container">
    <div class="permissions-list--items">
      <div
          class="permissions-list--item"
          v-for="cat in permissions"
          :key="cat.id"
      >
        <simple-select-checkbox
            :dataComponent="cat.permissions"
            :title="cat.catName"
            :default="cat.default"
            :reset="cat.reset"
            @changeValue="changePermSelect($event, cat.id)"
            class="mrg-t-15"
        ></simple-select-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import localRbacRepository from "../../../repositories/local/rbac";
import SimpleSelectCheckbox from "../../SimpleSelectCheckbox.vue";

export default {
  name: "PermissionsList",
  components: {SimpleSelectCheckbox},
  data() {
    return {
      permissions: [],
    };
  },
  props: {
    reset: Number, // При изменении сбрасывает компонент
    default: Array, // Устанавливает выбранные значения из списка dataComponent. На вход [id, id...],
    hideActions: Boolean // Скрывает экшены "Выбрать все" и "Снять все"
  },
  computed: {},
  watch: {
    reset: function(){
      for (let key in this.permissions) {
        this.permissions[key].reset = this.permissions[key].reset + 1;
      }
    },
    default: function(val) {
      for (let key in this.permissions) {
        this.permissions[key].default = [];
        for (let keyPerm in this.permissions[key].permissions) {
          this.$set(this.permissions[key].permissions[keyPerm], "checked", false);
        }
      }
      if(val && val.length){
        for(let keyDef in val){
          for (let key in this.permissions) {
            for (let keyPerm in this.permissions[key].permissions) {
              if (this.permissions[key].permissions[keyPerm].id === val[keyDef]) {
                this.$set(this.permissions[key].default, this.permissions[key].default.length, val[keyDef]);
              }
            }
          }
        }
      }
    }
  },
  methods: {
    changePermSelect(val, catId) {
      let selectedPermissions = [];
      for (let key in this.permissions) {
        if (this.permissions[key].id === catId) {
          this.permissions[key].selectedPermissions = val;
        }
        selectedPermissions = selectedPermissions.concat(this.permissions[key].selectedPermissions);
      }
      this.emitList(selectedPermissions);
    },
    emitList(value) {
      this.$emit('changeValue', value);
    },
    filterDataCatList(data){
      this.permissions = [];
      for (let key in data) {
        let catObj = {};
        catObj.id = data[key].category;
        catObj.catName = data[key].categoryDescription;
        catObj.permissions = [];
        catObj.selectedPermissions = [];
        catObj.default = [];
        catObj.reset = 0;

        for (let keyPerm in data[key].permissions) {
          let obj = {};
          obj.id = data[key].permissions[keyPerm].name;
          obj.name = data[key].permissions[keyPerm].description;
          obj.checked = false;
          catObj.permissions.push(obj);
        }

        this.permissions.push(catObj);
      }
    }
  },
  created() {
    this.filterDataCatList(localRbacRepository.getPermissions());
  }
};
</script>

<style scoped lang="less">

</style>